var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgDirectionLeftRight = function SvgDirectionLeftRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 23,
    fill: "none",
    viewBox: "0 0 29 23",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.865 13.003h11.342v-2.92c0-.565.343-.718.762-.34l2.382 2.147 1.524 1.374 2.382 2.148a.91.91 0 0 1 0 1.374l-2.382 2.147-1.524 1.373-2.382 2.148c-.42.377-.762.225-.762-.339v-2.921H9.865zM18.705 9.658H7.364v2.92c0 .565-.343.717-.762.34L4.22 10.769c-.42-.377-1.104-.995-1.524-1.373L.314 7.25a.91.91 0 0 1 0-1.374l2.382-2.148L4.22 2.354 6.602.207c.419-.377.762-.225.762.34v2.92h11.34z"
  })));
};
export default SvgDirectionLeftRight;